import {
  CampaignAwarded,
  CampaignAwardedDetail,
  CreateCampaignAwardedData,
  UpdateCampaignAwardedData,
  PeopleAwardeds,
} from "../types/campaignAwarded";
import api from "./api";

export const listCampaignsAwarded = async (): Promise<CampaignAwarded[]> => {
  const response = await api.get("/campaign-awarded-:stage/prize-draw/list");

  return response.data.content;
};

export const listCampaignAwardeds = async (
  id: number
): Promise<PeopleAwardeds[]> => {
  const response = await api.get(`/campaign-awarded-:stage/awardeds/${id}`);

  return response.data.content;
};

export const findCampaignAwarded = async (
  id: number
): Promise<CampaignAwardedDetail> => {
  const response = await api.get(`/campaign-awarded-:stage/prize-draw/${id}`);

  return response.data.content;
};

export const createCampaignsAwarded = async (
  data: CreateCampaignAwardedData
): Promise<any> => {
  const payloadAwardedData = {
    name: data.name,
    ranking: data.top_ranking,
    insight_id:
      data.public === "insight" ? data.target?.idListProspectei : null,
    form_id: data.public === "form" ? data.target?.id_formulario : null,
  };

  const response = await api.post(
    "/campaign-awarded-:stage/prize-draw/store",
    payloadAwardedData
  );

  return response.data;
};

export const updateCampaignsAwarded = async (
  data: UpdateCampaignAwardedData
): Promise<any> => {
  const payloadAwardedData = {
    id: data.id,
    name: data.name,
    ranking: data.top_ranking,
    insight_id:
      data?.insight_id || data.public === "insight"
        ? data.target?.idListProspectei
        : null,
    form_id:
      data?.form_id || data.public === "form"
        ? data.target?.id_formulario
        : null,
    active: data.active,
    video: data.video,
  };

  const response = await api.put(
    "/campaign-awarded-:stage/prize-draw/update",
    payloadAwardedData
  );

  return response.data;
};

export const randomAward = async (id: number) => {
  const payload = { id };
  const response = await api.post(
    "/campaign-awarded-:stage/prize-draw/random",
    payload
  );

  return response.data.content;
};
